function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const SHAPES = [
  {
    id: 'circle',
    name: 'Circle',
    color: '#ef4444',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><circle cx="100" cy="100" r="85" fill="#ef4444" stroke="#b91c1c" stroke-width="4"/></svg>',
  },
  {
    id: 'square',
    name: 'Square',
    color: '#3b82f6',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="20" width="160" height="160" rx="4" fill="#3b82f6" stroke="#1d4ed8" stroke-width="4"/></svg>',
  },
  {
    id: 'triangle',
    name: 'Triangle',
    color: '#f59e0b',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><polygon points="100,15 185,180 15,180" fill="#f59e0b" stroke="#d97706" stroke-width="4"/></svg>',
  },
  {
    id: 'rectangle',
    name: 'Rectangle',
    color: '#10b981',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><rect x="15" y="50" width="170" height="100" rx="4" fill="#10b981" stroke="#059669" stroke-width="4"/></svg>',
  },
  {
    id: 'oval',
    name: 'Oval',
    color: '#8b5cf6',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><ellipse cx="100" cy="100" rx="90" ry="60" fill="#8b5cf6" stroke="#7c3aed" stroke-width="4"/></svg>',
  },
  {
    id: 'semicircle',
    name: 'Semi-circle',
    color: '#ec4899',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><path d="M 15 140 A 85 85 0 0 1 185 140 Z" fill="#ec4899" stroke="#db2777" stroke-width="4"/></svg>',
  },
  {
    id: 'pentagon',
    name: 'Pentagon',
    color: '#f97316',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><polygon points="100,15 190,75 155,175 45,175 10,75" fill="#f97316" stroke="#ea580c" stroke-width="4"/></svg>',
  },
  {
    id: 'hexagon',
    name: 'Hexagon',
    color: '#06b6d4',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><polygon points="55,15 145,15 190,100 145,185 55,185 10,100" fill="#06b6d4" stroke="#0891b2" stroke-width="4"/></svg>',
  },
  {
    id: 'diamond',
    name: 'Diamond',
    color: '#a855f7',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><polygon points="100,10 185,100 100,190 15,100" fill="#a855f7" stroke="#9333ea" stroke-width="4"/></svg>',
  },
  {
    id: 'star',
    name: 'Star',
    color: '#eab308',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><polygon points="100,10 125,75 195,75 140,120 160,185 100,145 40,185 60,120 5,75 75,75" fill="#eab308" stroke="#ca8a04" stroke-width="4"/></svg>',
  },
  {
    id: 'heart',
    name: 'Heart',
    color: '#e11d48',
    svg: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><path d="M100,180 C60,140 10,110 10,65 C10,30 40,10 70,10 C85,10 95,20 100,30 C105,20 115,10 130,10 C160,10 190,30 190,65 C190,110 140,140 100,180Z" fill="#e11d48" stroke="#be123c" stroke-width="4"/></svg>',
  },
];

export function getShapeQuestions(count = 5) {
  const selected = shuffle(SHAPES).slice(0, Math.min(count, SHAPES.length));

  return selected.map((shape) => {
    const others = SHAPES.filter((s) => s.id !== shape.id);
    const distractors = shuffle(others).slice(0, 3);
    const options = shuffle([shape, ...distractors]);
    const correctIndex = options.findIndex((o) => o.id === shape.id);

    return {
      id: shape.id,
      shape,
      options: options.map((o) => o.name),
      correctIndex,
    };
  });
}
